import { useState } from "react";
import { Chart } from "react-google-charts";
import { useQuery } from "@tanstack/react-query";
import { client_v2 } from "utils/api";
import { Loader } from "components";

import ModalGdnLinePickerMissings from "./components/ModalGdnLinePickerMissings";
import ModalPackerUnControlledMissing from "./components/ModalPackerUnControlledMissing";

const MissingsHistorgram = () => {
  const [details_data, setDetailsData] = useState(null);
  const { isLoading, isFetching, data } = useQuery(
    ["gdn_line_picker_missings"],
    () => client_v2.get("/stats/gdn_line_picker_missings"),
    {
      select: (res) => res.data,
      retry: false,
    }
  );

  const is_loading = isLoading || isFetching;

  return (
    <>
      {details_data?.date && (
        <>
          {details_data.type === "gdn_line_picker_missing" && (
            <ModalGdnLinePickerMissings
              {...details_data}
              handleClose={() => setDetailsData(null)}
            />
          )}
          {["pieceworker_missing", "uncontrolled_missing"].includes(
            details_data.type
          ) && (
            <ModalPackerUnControlledMissing
              {...details_data}
              handleClose={() => setDetailsData(null)}
            />
          )}
        </>
      )}
      <div className="dashboard">
        <div className="dashboard__header">
          <h2 className="dashboard__title heading">Zgłoszone braki</h2>
          {is_loading && <Loader size="20" />}
        </div>
        <div className="chart-box__body">
          {data?.length > 0 && (
            <Chart
              options={{
                colors: ["#0abb87", "#f56565", "#ffb822", "#000000"],
                chartArea: { width: "85%" },
                vAxis: { minValue: 0, maxValue: 25 },
                hAxis: {
                  textStyle: {
                    fontSize: 10,
                    color: ["#595D6E"],
                  },
                },
                legend: { position: "none" },
              }}
              chartType="ColumnChart"
              loader={null}
              width="100%"
              height="300px"
              data={[
                [
                  "Data",
                  "Ilość potencjalnych braków rozpatrzona pozytywnie",
                  "Ilość potencjalnych braków rozpatrzona negatywnie",
                  "Ilość braków zgłoszonych przez pakera bez kontroli",
                  "Ilość braków zgłoszonych przez pracowników akordowych",
                ],
                ...data,
              ]}
              chartEvents={[
                {
                  eventName: "select",
                  callback: ({ chartWrapper }) => {
                    const chart = chartWrapper.getChart();
                    const selection = chart.getSelection();
                    if (selection.length > 0) {
                      const { row, column } = selection[0];
                      if (column === null || row === null) return;
                      setDetailsData({
                        date: data[row]?.[0],
                        type:
                          column === 3
                            ? "uncontrolled_missing"
                            : column === 4
                            ? "pieceworker_missing"
                            : "gdn_line_picker_missing",
                        approver_decision:
                          column === 3 || column === 4
                            ? null
                            : column === 2
                            ? "declined"
                            : "approved",
                      });
                    }
                  },
                },
              ]}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default MissingsHistorgram;
